/* eslint-disable */
import * as types from './mutation-types'
import { StoreKey } from '@/utils/config.js'

const mutations = {
    setLoginVisible(state, bool) {
        state.loginVisible = bool
    },
    reset(state) {
        state.userInfo = {}
        state.cartNum = 0
        localStorage.setItem(StoreKey, JSON.stringify(state))
    },
    [types.SET_USERINFO](state, obj) {
        state.userInfo = obj
        localStorage.setItem(StoreKey, JSON.stringify(state))
    },
    [types.SET_CARTNUM](state, num) {
        state.cartNum = num
    }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js